import StandardRestError from './Standard'

class PageBankExhaustedError extends StandardRestError {
  static CODE = 'PAGE_BANK_EXHAUSTED'

  constructor(_serverMessage?: string, status = 402, body = {}) {
    super('Not enough page credits to extract these files.', status, body)
  }
}

export default PageBankExhaustedError
